import { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';
import type AnalyticsWebClient from '@atlassiansox/analytics-web-client';
import { tenantType, userType } from '@atlassiansox/analytics-web-client';

import { JourneyLocalStorage } from '@/utils/local-storage-hook';

import { getIdentityTeamType, getProductQueryParamTeamType } from '../models/user-segmentation';

const eventSource = 'wacProvisioningScreen';
const eventSubject = 'tailored-onboarding';
const eventSubjectId = 'jira';

export type TailoredOnboardingEventArgs = {
	cloudId?: string;
	createAnalyticsEvent: CreateUIAnalyticsEvent;
	persona?: string;
	analyticsClient: AnalyticsWebClient | null;
	userCompletedOnboardingSteps: boolean;
	selectedTeamType?: string;
	accountId?: string;
	localStorageObj?: JourneyLocalStorage;
	jtbd?: string;
};

export const tryTriggerTailoredOnboardingInitializedEvent = ({
	analyticsClient,
	cloudId,
	accountId,
	createAnalyticsEvent,
	selectedTeamType,
	persona,
	userCompletedOnboardingSteps,
	localStorageObj,
	jtbd,
}: TailoredOnboardingEventArgs) => {
	if (
		analyticsClient &&
		userCompletedOnboardingSteps &&
		selectedTeamType &&
		persona &&
		cloudId &&
		accountId
	) {
		analyticsClient.setTenantInfo(tenantType.CLOUD_ID, cloudId);
		analyticsClient.setUserInfo(userType.ATLASSIAN_ACCOUNT, accountId);
		createAnalyticsEvent({
			source: eventSource,
			actionSubject: eventSubject,
			action: 'initialized',
			actionSubjectId: eventSubjectId,
			attributes: {
				anchor: localStorageObj?.anchor?.name,
				type: localStorageObj?.anchor?.type,
				team: getIdentityTeamType(selectedTeamType),
				teamTypeInferredMl: localStorageObj?.teamTypeInferredMl,
				page_url: `${window.location.origin}/ondemand/signup/confirmation`,
				page_path: '/ondemand/signup/confirmation',
				persona: persona,
				tt: getProductQueryParamTeamType(selectedTeamType),
				jtbd,
			},
			eventType: 'track',
		}).fire();
		return true;
	}
	return false;
};

export const triggerTailoredOnboardingEvent = (
	tailoredOnboardingEventArgs: TailoredOnboardingEventArgs,
) => {
	const {
		persona,
		cloudId,
		analyticsClient,
		accountId,
		createAnalyticsEvent,
		userCompletedOnboardingSteps,
		selectedTeamType,
	} = tailoredOnboardingEventArgs;
	const success = tryTriggerTailoredOnboardingInitializedEvent(tailoredOnboardingEventArgs);
	if (!success && persona) {
		cloudId && analyticsClient?.setTenantInfo(tenantType.CLOUD_ID, cloudId);
		accountId && analyticsClient?.setUserInfo(userType.ATLASSIAN_ACCOUNT, accountId);
		createAnalyticsEvent({
			source: eventSource,
			actionSubject: eventSubject,
			action: 'skipped',
			actionSubjectId: eventSubjectId,
			attributes: {
				userCompletedOnboardingSteps,
				selectedTeamType,
				cloudId,
				persona: persona,
				accountId: accountId,
			},
			eventType: 'track',
		}).fire();
	}
};
